import { QueryStats } from "@mui/icons-material";

const statistics = {
    id: 'statistics',
    type: 'group',
    children: [
        {
            id: 'statistics-menu',
            title: 'Statistics',
            type: 'item',
            icon: QueryStats,
            url: '/statistics',
            target: false,
            requiredPermission: 'Estadísticas',
            adminOnly: true
        }
    ]
};

export default statistics;
